import { defaultParseSearch } from '@tanstack/react-router';

/** Router `parseSearch`: a repeated key keeps its first value. The default
 *  parser returns an array for `?tab=a&tab=b`, which layouts reading the raw
 *  search (the admin share control) cannot handle — spec §7a Hygiene, E2E O2.
 *  No search schema in the apps takes an array. */
export function parseSearchFirstValue(searchStr: string): Record<string, unknown> {
  const parsed = defaultParseSearch(searchStr) as Record<string, unknown>;
  return Object.fromEntries(Object.entries(parsed).map(([key, value]) => [key, Array.isArray(value) ? value[0] : value]));
}
